// import React from 'react';
import { projects } from '../data/projects';
import { Project } from '../types/project';
import ProjectTile from './ProjectTile';

const WritingPage: React.FC = () => {
  const writingProjects = projects.filter(p => p.category === 'writing');

  return (
    <div>
      <h2>Writing Projects</h2>
      <div className="project-list">
        {writingProjects.length > 0 ? (
          writingProjects.map((project: Project) => (
            <ProjectTile key={project.id} project={project} />
          ))
        ) : (
          <p>No writing projects yet!</p>
        )}
      </div>
    </div>
  );
};

export default WritingPage;
